import React from 'react';

const reasons = [
  { n:'01', title:'Precision Engineering', desc:'Every system is architected for long-term performance. We write code that is clean, documented, and maintainable years after delivery.' },
  { n:'02', title:'Dedicated Studio Teams', desc:'You get a hand-picked team — lead developer, designer, QA engineer, and PM — fully committed to your product.' },
  { n:'03', title:'Transparent Process', desc:'Bi-weekly demos, daily Slack updates, open sprint boards. No surprises, no hidden costs, ever.' },
  { n:'04', title:'Security by Default', desc:'Every project is built OWASP-compliant with data encryption, secure auth, and regular vulnerability scanning.' },
];

const WhyChooseUs = () => (
  <section className="section-pad" style={{ background:'var(--bg2)' }}>
    <div className="container">
      <div className="row g-5 align-items-center">
        {/* Left mosaic */}
        <div className="col-lg-5 d-none d-lg-block">
          <div className="mosaic-grid">
            <div className="tile-tall" style={{ overflow:'hidden' }}>
              <img className="mosaic-img" style={{ height:'100%' }}
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&auto=format&fit=crop&q=70"
                alt="Team collaboration" />
            </div>
            <div style={{ overflow:'hidden' }}>
              <img className="mosaic-img" style={{ height:210 }}
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?w=600&auto=format&fit=crop&q=70"
                alt="Mobile development" />
            </div>
            <div style={{ overflow:'hidden' }}>
              <img className="mosaic-img" style={{ height:210 }}
                src="https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=600&auto=format&fit=crop&q=70"
                alt="Design" />
            </div>
          </div>
        </div>

        {/* Right content */}
        <div className="col-lg-7">
          <span className="section-label">Why Cegon Soft Tech</span>
          <h2 className="section-title mb-4">Built for Growth.<br/><em>Built for Trust.</em></h2>
          <p className="section-sub mb-5">Eight years of delivering digital excellence has taught us that the best technology is invisible — it just works, beautifully and reliably.</p>

          <div style={{ borderTop:'1px solid var(--border)' }}>
            {reasons.map((r, i) => (
              <div key={i} style={{ display:'flex', gap:28, padding:'28px 0', borderBottom:'1px solid var(--border)' }}>
                <span style={{ fontFamily:'var(--font-disp)', fontSize:'1.1rem', color:'var(--tan2)', flexShrink:0, lineHeight:1 }}>{r.n}</span>
                <div>
                  <h5 style={{ fontFamily:'var(--font-disp)', fontWeight:500, fontSize:'1.2rem', marginBottom:8, color:'var(--cream2)' }}>{r.title}</h5>
                  <p style={{ color:'var(--muted)', fontSize:'0.85rem', lineHeight:1.8, margin:0, fontWeight:300 }}>{r.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
